function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoicemail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M6.9,8.9a1.26,1.26,0,0,0-1.07.64,2.58,2.58,0,0,0-.35,1.36c.11,1.2,1.54,2.2,2.36,2.74,7.71,5.23,5.78,5.64,11.63,1.43,1.28-.93,3.07-1.86,3.85-3a2.27,2.27,0,0,0,.15-2.64c-.58-.64-1.08-.56-1.94-.56H8.59A15.89,15.89,0,0,0,6.9,8.9Z",
    style: {
      fill: "#eac282"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.67,23.05a3,3,0,0,0-2.14-.93,3.17,3.17,0,0,0-3.14,3.15,3,3,0,0,0,.42,1.63H18.53A4.13,4.13,0,0,0,19,25.33a3.13,3.13,0,0,0-5.35-2.24,3.35,3.35,0,0,0-.86,2.24,3.22,3.22,0,0,0,.86,2.14,3.14,3.14,0,0,0,2.24.93h7.68a3.12,3.12,0,0,0,3-3.2,3.19,3.19,0,0,0-.9-2.11ZM17,26.31a1.72,1.72,0,0,1-1.15.49,1.7,1.7,0,0,1-1.57-1.57,1.53,1.53,0,0,1,.5-1.14,1.49,1.49,0,0,1,1.07-.45A1.54,1.54,0,0,1,17,26.31Zm7.56,0a1.49,1.49,0,0,1-2.21,0,1.43,1.43,0,0,1-.43-1.08,1.5,1.5,0,0,1,1.4-1.59h.17a1.43,1.43,0,0,1,1.07.43A1.57,1.57,0,0,1,25,25.23a1.62,1.62,0,0,1-.45,1.08Z",
    style: {
      fill: "#7c7c7c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,23.31h-.07a2.85,2.85,0,0,0-.81-1.07,4.21,4.21,0,0,0-3-1.29,4.29,4.29,0,0,0-3,1.29,3.82,3.82,0,0,0-.75,1.07H7.18A1.63,1.63,0,0,1,5.54,22a8,8,0,0,1-.06-1.38V13.53c1.42,1.34,7.77,5.84,9.2,5.84s7.71-4.5,9.14-5.85V20.9h0A4.29,4.29,0,0,0,20,23.31Z",
    style: {
      fill: "#eac282"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoicemail);
export default __webpack_public_path__ + "static/media/invoicemail.66d59972.svg";
export { ForwardRef as ReactComponent };